import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

interface InformationCardContentMembersSitesProps {
  id: string;
  description: any;
}

const InformationCardContentMembersSites: React.FC<InformationCardContentMembersSitesProps> = ({ id, description }) => {
  const { t } = useTranslation();
  const params = useParams();
  const entityId = params.id as string;

  const { entities, sortedEntities } = useSelector((state: any) => state.metadata);
  
  const community = (sortedEntities?.communities || [])?.find((entity: any) => (entity?.communityId || entity.id) === entityId);


  const siteTypeCounts: Record<string, number | null> = {
    consumer: 0,
    producer: 0,
    prosumer: 0,
    prosumage: 0,
  };

  (community?.members || [])?.forEach((member: any) => {
    (member?.sites || [])?.forEach((site: any) => {
      if (Array.isArray(site.siteType)) {
        site.siteType.forEach((type: any) => {
          if (
            type.siteType &&
            Object.prototype.hasOwnProperty.call(siteTypeCounts, type.siteType)
          ) {
            siteTypeCounts[type.siteType]!++;
          }
        });
      } else if (typeof site.siteType === 'string') {
        if (siteTypeCounts.hasOwnProperty(site.siteType)) {
          siteTypeCounts[site.siteType]!++;
        }
      }
    });
  });

  for (const key in siteTypeCounts) {
    if (siteTypeCounts[key] === 0) {
      siteTypeCounts[key] = null;
    }
  }

  const keys = description.map((el: any) => el.key.split('.').slice(-1).pop());

  return (
    <>
      {keys
        .filter((el: any) => siteTypeCounts[el] !== null)
        .map((siteType: string, i: number, array: any) => {
          const label = description.find((desc: any) => desc.key.includes(siteType));
          return (
            <span key={`${id}-label-value-label-value-${i}`} className="paragraph">
              {t(label.key)}: {siteTypeCounts[siteType]}{' '}
              {i < array.length - 1 ? '|' : ''}&nbsp;
            </span>
          );
        })}
      <div className={'paragraph'}>{t('widgets.communitySitesCard.members')}:{' '}{community?.members?.length || 0}</div>
    </>
  );
};


export default InformationCardContentMembersSites; 